module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAALCAYAAAB7/H1+AAAAcElEQVQ4T82T2w2AIAxFT53CqXQLdSRgQZnCEj6QhIDxA4z9afrI7e1L1LFwYRFmeojimdhFDWc30EzMi1r0tjcFJzmc7KhLiXktP/AeuFYwFSsJfQvcavm/jFvLG8a4NqLH5Q27Y8MKmG5PEj8PjgArImP40h4FKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/hot.png
// module id = fN5a
// module chunks = 1